export enum OneSchemaTemplateKey {
	CAP_TRANSACTIONS_UPLOAD = 'cap_transactions_upload',
	CAP_TRANSACTIONS_UPLOAD_COMPLEX = 'cap_transactions_upload_complex',
	CAP_SECURITIES_UPLOAD = 'cap_securities_upload',
	UPLOAD_MANAGEMENT_LOANS = 'upload_management_loans',
	UPLOAD_NATURAL_PERSONS = 'upload_natural_persons',
	UPLOAD_LEGAL_PERSONS = 'upload_legal_persons',
	UPLOAD_SHARE_ASSOCIATIONS = 'upsert_allocations',
}
